import {
    Box,
    Button,
    CheckBox,
    Form,
    RadioButton,
    Text,
    TextInput,
} from "grommet";
import { Checkbox, Close, Search } from "grommet-icons";
import React from "react";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { InstObject } from "../config/types";
import { ImArrowRight } from "react-icons/im";
import useInst from "../hooks/useInst";
import AInstCard from "./AInstCard";
import InstList from "./InstList";
import { RecoilState, useRecoilState } from "recoil";
import { selectedInstsR } from "../recoils/selectedInsts";
import InstSelectBox from "./InstSelectBox";

const SearchInst = () => {
    let navigate = useNavigate();

    const [pageLayout, setPageLayout] = React.useState("first");
    const [textInput, setTextInput] = React.useState("");
    const [searchname, setSearchName] = React.useState<string>("");
    const [inputPlaceholder, setInputPlaceHolder] =
        React.useState("기관명을 입력하세요 ...");

    const handleTextInput = () => {
        if (textInput !== "") {
            let charax = textInput.length;
            let nofSpace = textInput.split(" ").length - 1;
            if (charax !== nofSpace && charax > 1) {
                searchInst();
            }
            setSearchName(textInput);
        }
    };
    const [received, setReceived] = React.useState(false);
    const [instsData, setInstsData] = React.useState<any>([]);

    const searchInst = async () => {
        setReceived(false);
        setInstsData([[]]);
        // 검색량이 많은 단어 입력시 렌더링 지연.. 금지어 필터링 필요...

        const res = await useInst.getInstsByName(textInput);
        console.log("searchInst", res);
        // remove inst with no name
        res.insts = res.insts.filter((p: any) => {
            return (
                p.inst.primaryname !== "" && p.inst.primaryname !== "nan"
            );
        });

        // sort by primaryname_ko
        res.insts.sort((a: any, b: any) => {
            if (a.inst.primaryname_ko < b.inst.primaryname_ko) {
                return -1;
            }
            if (a.inst.primaryname_ko > b.inst.primaryname_ko) {
                return 1;
            }
            return 0;
        });
        setReceived(true);
        setInstsData(res.insts);
    };

    return (
        <Box
            width="full"
            direction="column"
            align="center"
            justify="start"
            style={{ maxWidth: "1000px" }}
            height="full"
        >
            <Box
                direction="column"
                width="390px"
                align="center"
                justify="start"
                style={{ minHeight: "70px", maxHeight: "70px" }}
            >
                <Form onSubmit={() => handleTextInput()}>
                    <Box
                        direction="row"
                        round="xsmall"
                        align="center"
                        style={{ minHeight: "50px", maxHeight: "50px" }}
                    >
                        <Box
                            direction="row"
                            align="center"
                            justify="center"
                            width="250px"
                        >
                            <HiOutlineBuildingOffice size="30px" />
                            <Text size="20px" margin="10px" weight="bold">
                                기관
                            </Text>
                        </Box>

                        <Box
                            border={{
                                color: "grey",
                                style: "solid",
                                side: "bottom",
                            }}
                            height="40px"
                            margin={{ horizontal: "10px" }}
                            width="full"
                        >
                            <TextInput
                                plain
                                focusIndicator={false}
                                placeholder={
                                    textInput.length === 0 ? (
                                        <Text size="15px" color="logo-loupe">
                                            {inputPlaceholder}
                                        </Text>
                                    ) : (
                                        ""
                                    )
                                }
                                value={textInput}
                                onChange={(e) =>
                                    setTextInput(e.currentTarget.value)
                                }
                            />
                        </Box>
                        {textInput.length > 0 ? (
                            <Button
                                icon={<Close size="small" />}
                                onClick={() => {
                                    setTextInput("");
                                }}
                            />
                        ) : (
                            <Button
                                icon={<Close size="small" color="white" />}
                                disabled
                            />
                        )}

                        <Button
                            icon={
                                <Search
                                    size={
                                        pageLayout === "first"
                                            ? "medium"
                                            : "20px"
                                    }
                                />
                            }
                            type="submit"
                        />
                    </Box>
                </Form>
            </Box>
            {/* 선택 기관 목록 */}
            <Box
                style={{ minHeight: "150px", maxHeight: "150px" }}
                width="full"
            >
                <InstSelectBox />
            </Box>

            {/* result */}

            <Box
                width="full"
                height="full"
                align="start"
                justify="start"
                alignSelf="start"
            >
                <Box alignSelf="start">
                    <Text size="12px" margin="20px">
                        기관명 :
                        {searchname && searchname.length > 0 && (
                            <Text
                                margin={{ horizontal: "5px" }}
                                size="12px"
                                weight="bold"
                            >
                                "{searchname}"
                            </Text>
                        )}{" "}
                        검색결과 :{" "}
                        <Text
                            margin={{ horizontal: "5px" }}
                            size="12px"
                            weight="bold"
                        >
                            {instsData.length}
                        </Text>
                    </Text>
                </Box>
                {received && <InstList instData={instsData} />}
            </Box>
        </Box>
    );
};

export default SearchInst;
